import React, {
  FunctionComponent,
  useRef,
  useImperativeHandle,
  ReactNode,
} from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  title?: string | ReactNode;
  children: any;
}
const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: 'var(--bgColor)',
    color: 'var(--mainColor)',
    // border: '1px solid var(--borderColor)',
    boxShadow: theme.shadows[1],
    textTransform: 'capitalize',
    fontSize: 11,
    '& .MuiTooltip-arrow': {
      color: 'var(--bgColor)',
      // border: '1px solid var(--borderColor)',
    },
    fontFamily: 'chirp',
  },
}));
const ToolTipComp: FunctionComponent<Props> = React.forwardRef(
  ({ children, title }, ref) => {
    const classes = useStyles();
    const tooltipRef = useRef<any>(null);
    useImperativeHandle(ref, () => ({
      focusInput: () => {
        tooltipRef.current.openTooltip();
      },
    }));
    return (
      <Tooltip
        classes={{ tooltip: classes.tooltip }}
        TransitionComponent={Zoom}
        arrow
        title={title ? title : ''}
        dir="auto"
        data-testid="Tooltip"
        ref={tooltipRef}
      >
        {children}
      </Tooltip>
    );
  },
);

export default ToolTipComp;
